import { render } from "./Team_index_en.vue?vue&type=template&id=3d77f3cc&scoped=true"
import script from "./Team_index_en.vue?vue&type=script&lang=js"
export * from "./Team_index_en.vue?vue&type=script&lang=js"

import "./Team_index_en.vue?vue&type=style&index=0&id=3d77f3cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d77f3cc"

export default script